import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { usePageTitle } from '../hooks/usePageTitle';

export default function NotFoundPage() {
  usePageTitle('Page Not Found · Kast');

  return (
    <div
      className="flex min-h-[calc(100vh-4rem)] items-center bg-cover bg-center"
      style={{ backgroundImage: "url(/not-found.jpg)" }}
    >
      <div className="mx-auto w-full max-w-[1600px] gutter py-32">
        <p className="text-gold-gradient display text-[clamp(4rem,14vw,9rem)] leading-none">404</p>

        <h1 className="display mt-4 max-w-[16ch] text-[clamp(1.75rem,4vw,3rem)] text-balance">
          This page is not on Kast
        </h1>
        <p className="mt-4 max-w-[50ch] text-base text-white/90">
          The link may be out of date, or the title may have left the catalogue.
        </p>

        <div className="mt-8 flex flex-wrap gap-3">
          <Button asChild size="lg" className="h-11 rounded-full bg-white px-7 font-semibold text-black hover:bg-white/90">
            <Link to="/">Back to home</Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="h-11 rounded-full border-white/25 bg-white/5 px-7 font-medium text-white hover:bg-white/10">
            <Link to="/categories">Browse genres</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
